<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <user-field-edit-form
        @on-submit="onUserFieldEditSubmit"
      ></user-field-edit-form>
    </div>
  </div>
</template>
<script>
import UserFieldEditForm from "./UserFieldEditForm.vue";

export default {
  components: {
    UserFieldEditForm
  },
  data() {
    return {
      userFieldEditModel: {}
    };
  },
  methods: {
    onUserFieldEditSubmit(model) {
      this.userFieldEditModel = model;
      // this.$http.post(
      //   this.$apiBaseUrl + 'users/field/' + this.userFieldEditModel.id, Object.assign(this.userFieldEditModel)
      // ).then(response => {
      // }, response => {
      // });
    }
  }
};
</script>
<style></style>
